<template>
  <div class="AHome">
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item
        v-for="(item,index) in ZhScheduleList"
        :key="index"
        :title="item.name"
        :name="index + 1"
        class="aaa"
      >
        <div class="collapse_left">
          <div class="title">尊敬的{{ Name }}</div>
          <p>
            感谢您注册参观
            <span>{{ item.name }}</span>
          </p>
          <p>您的预登记信息如下：</p>
          <p>
            预登记编号：
            <span>{{ item.myCode }}</span>
          </p>
          <p>
            姓名：
            <span>{{ Name }}</span>
          </p>
          <p>
            单位名称：
            <span>{{ Company }}</span>
          </p>
          <p>
            展会日期：
            <span>{{ `${item.starttime} -- ${item.stoptime}` }}</span>
          </p>
          <p>
            展会地址：
            <span>{{ item.address }}</span>
          </p>
          <p>
            展会地点：
            <span>{{ item.locale }}</span>
          </p>
          <p>
            官方网站：
            <span> http://www.cmee-online.com </span>
          </p>
          <p>
            咨询热线：
            <span>010-82210085</span>
          </p>
          <div class="tishi">*届时请您携带此确认函，至北京教育装备展示会现场自助换证机或人工换证通道换取胸卡，免费入场参观</div>
        </div>
        <div class="collapse_right">
          <div :id=" 'qrcode' + item.id "></div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { mapState } from "vuex";
import QRcode from "qrcodejs2";
export default {
  components: {
    QRcode,
  },
  data() {
    return {
      activeName: 1,
      ZhScheduleList: [],
      Name: "",
      Company: "",
    };
  },
  mounted() {
    // this.getCode()
    this.init();
    this.getInfo();
  },
  computed: mapState({
    name: (state) => state.GZUserInfo.name,
    city: (state) => state.GZUserInfo.city,
    company: (state) => state.GZUserInfo.company,
  }),
  methods: {
    // 初始化
    init() {
      this.$http({
        url: "viewer/getViewerzZHCode",
        method: "get",
        params: {},
      })
        .then(({ data }) => {
          let { code, ZhScheduleList } = data;
          if (code === 0) {
            setTimeout(() => {
              this.$nextTick(function () {
                ZhScheduleList.forEach((element) => {
                  this.qrcode("qrcode" + element.id, element.myCode);
                  element.starttime = element.starttime.substring(0,10);
                  element.stoptime = element.stoptime.substring(0,10);
                });
              });
            }, 100);
            this.ZhScheduleList = ZhScheduleList;
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/audLogin");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/audLogin");
        });
    },
    qrcode(qrcode, text) {
      let qrcode2 = new QRcode(qrcode, {
        width: 200,
        height: 200,
        text: "您的展会邀请码为" + text,
      });
    },
    getInfo() {
      this.$http({
        url: "viewer/viewerInfo",
        method: "get",
        params: {},
      })
        .then(({ data }) => {
          let { code, user } = data;
          if (code === 0 && user) {
            this.Name = user.name;
            this.Company = user.company;
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/audLogin");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/audLogin");
        });
    },
  },
};
</script>
<style lang="scss">
.AHome {
  .el-collapse-item__header {
    height: 66px;
    background-color: #f2f2f2;
    color: #143372;
    padding-left: 28px;
    font-size: 18px;
  }
  [class*=" el-icon-"],
  [class^="el-icon-"] {
    color: #143372;
  }
}
</style>
<style lang="scss" scoped>
.AHome {
  .collapse_left {
    width: 590px;
    float: left;
    padding: 0 0 40px 28px;
    color: #333333;
    .title {
      height: 18px;
      line-height: 18px;
      margin: 40px 0;
      font-size: 18px;
    }
    .tishi {
      height: 12px;
      line-height: 12px;
      color: #17a3dd;
      font-size: 12px;
      margin-top: 40px;
    }
    p {
      font-size: 14px;
      line-height: 30px;
    }
  }
  .collapse_right {
    width: 200px;
    height: 200px;
    float: right;
    margin-right: 30px;
    margin-top: 250px;
  }
}
</style>